import React, { useMemo } from 'react';
import TableContainer from 'components/Common/TableContainer';
import { Card, CardBody, CardTitle } from 'reactstrap';

const dummyActiveIngredients = [
  { id: '1', name: 'Acetaminophen', concentration: '500mg' },
  { id: '2', name: 'Caffeine', concentration: '65mg' },
];

const ActiveIngredientsTable = () => {
  const columns = useMemo(
    () => [
      { header: 'Name', accessorKey: 'name', enableColumnFilter: false, enableSorting: false },
      {
        header: 'Concentration',
        accessorKey: 'concentration',
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    [],
  );

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Active Ingredients</CardTitle>
        <TableContainer
          columns={columns}
          data={dummyActiveIngredients}
          isGlobalFilter={false}
          tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-borderless"
          theadClass="table-light"
          paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
          paginationClass="pagination"
        />
      </CardBody>
    </Card>
  );
};

export default ActiveIngredientsTable;
